import { useEffect, useRef, useState } from 'react'

import styles from './config-chips.module.scss'
import { ButtonHierarchy } from '@/components/styleguide/Button'
import { ChipGroup } from '@/components/styleguide/Chip'
import { isProd } from '@/lib/utilities/system'
import { Theme } from '@/types/system'

type ConfigChipsProps = {
  pageSections: Record<string, string>
  excludedChips: string[]
  onNavigationButtonClick: (chipId: string) => void
  isSticky?: boolean
  isAboveImage?: boolean
}

export const ConfigChips = ({
  pageSections,
  excludedChips,
  onNavigationButtonClick,
  hasBorderBottom = true,
  isSticky = false,
  isAboveImage = false,
}: ConfigChipsProps) => {
  const sections = Object.values(pageSections)
  const configChips = useRef(null)
  const [isAtTop, setIsAtTop] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (!configChips.current) {
        return
      }

      const rect = configChips.current.getBoundingClientRect()
      const isTop = rect.top <= 2 && rect.bottom >= 0

      setIsAtTop(isTop)
    }

    window.addEventListener('scroll', handleScroll, { passive: true })
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  return (
    <div
      ref={configChips}
      className={`${styles.navigation} ${isSticky && styles.sticky} ${isAtTop && isSticky ? styles.top : ''} ${isAboveImage ? styles['above-image'] : ''} ${hasBorderBottom ? styles['has-border-bottom'] : ''}`}>
      <ChipGroup
        className={styles.chips}
        theme={Theme.light}
        active={['Overview']}
        chips={sections
          .filter(value => !excludedChips.includes(value))
          .map(item => ({
            chipId: item,
            label: item,
            chipType: ButtonHierarchy.ChipChoice,
            className: !isProd()
              ? `configurator-toolbar__${item.replaceAll(' ', '-').toLowerCase()}--mobile`
              : '',
          }))}
        onChipChange={chipId => onNavigationButtonClick(chipId)}
      />
    </div>
  )
}
